<template lang="">
    <div class="modal">
        <a class="modal_close" @click="$emit('close')"></a>
        <div class="modal_header">
            <div class="title">디지털화환 구매하기</div>
            <p class="txt">{{ modalData.campaignName }} ( 기본 운영비 : {{ $addComma(modalData.paymentAmount) }}원 )</p>
            <p class="txt">총 금액 : {{ $addComma(totalAmount) }}원</p>
        </div>
        <form ref="paymentForm" method="POST" accept-charset="EUC-KR" :action="formAction">
        <div class="modal_body">
            <div class="member">
                <div class="form_wrap">
                    <p class="title">기부금</p>
                    <select class="select_message ellipsis" v-model.number="selectedExtra">
                        <option :value="10000">10,000원</option>
                        <option :value="30000">30,000원</option>
                        <option :value="50000">50,000원</option>
                        <option :value="100000">100,000원</option>
                    </select>
                </div>
                <div class="form_wrap">
                    <p class="title">성함</p>
                    <input type="text" placeholder="성함을 입력해주세요." name="USERNAME"  v-model="kiwoompay.username">
                </div>
                <div class="form_wrap">
                    <p class="title">전화번호</p>
                    <input type="text" placeholder="전화번호를 입력해주세요." name="MOBILENO" 
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="kiwoompay.phonenum = (kiwoompay.phonenum || '').replace(/\D/g,'')"
                        v-model="kiwoompay.phonenum">
                </div>
                <div class="form_wrap">
                    <p class="title">이메일</p>
                    <input type="text" placeholder="이메일을 입력해주세요." name="EMAIL"  v-model="kiwoompay.email">
                </div>
                <div class="form_wrap">
                    <p class="title">메시지</p>
                    <select
                        class="select_message ellipsis"
                        v-model="selectedMessage"
                    >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in messageOptions" :key="index" :value="msg">
                            {{ msg }}
                        </option>
                    </select>
                </div>
                <div class="form_wrap">
                    <p class="title"></p>
                    <textarea class="textarea" placeholder="메시지를 입력해주세요." v-model="kiwoompay.message"></textarea>
                </div>
                <button type="button" class="btn_login" @click="makePayment">{{ buttonText }}</button>
            </div>
        </div>
        <input type="hidden" name="CPID" v-model="kiwoompay.cpid">
        <input type="hidden" name="ORDERNO" v-model="kiwoompay.orderno">
        <input type="hidden" name="TYPE" v-model="kiwoompay.type">
        <input type="hidden" name="PAYMETHOD" v-model="kiwoompay.paymethod">
        <input type="hidden" name="AMOUNT" v-model="totalAmount">
        <input type="hidden" name="PRODUCTNAME" v-model="kiwoompay.productname">
        <input type="hidden" name="PRODUCTTYPE" v-model="kiwoompay.producttype">

        <input type="hidden" name="USERID" v-model="kiwoompay.email">

        <input type="hidden" name="TAXFREECD" v-model="kiwoompay.taxfreecd">
        <input type="hidden" name="TELNO2" v-model="kiwoompay.teln02">
        <input type="hidden" name="KIWOOM_ENC" v-model="kiwoompay.kiwoomEnc">
        <input type="hidden" name="status" v-model="kiwoompay.status">

        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import env from '@/env';
import PortOne from "@portone/browser-sdk/v2";
import axiosInst from '@/utility/axiosInst';

const paymentModule = 'paymentModule'
const apiGuideModule = 'apiGuideModule'

export default {
    props: {
      orderNum: {
          type: String,
          required: true,
      }
    },
    data () {
        return {
            formAction: env.api.KIWOOM_URL,
            buttonText: '구매하기',
            selectedExtra: 10000,

            kiwoompay: {
                orderno: '',
                cpid: env.api.CPID,
                type: '',
                paymethod: 'CARD',
                amount: '',
                username: '',
                email: '',
                productname: '',
                producttype: '2',
                taxfreecd: env.api.KIWOOM_TAXFREECD,
                teln02: '0',
                kiwoomEnc: '',
                phonenum: '',
                message: '',
                status: ''
            },
            // 부고(F)용 애도 메시지
            funeralMessageOptions: [
                '깊은 애도의 마음을 전합니다.',
                '고인을 추모하며 깊은 애도를 표합니다.',
                '사랑과 감사의 마음으로 고인을 추모합니다.',
                '고인의 삶과 사랑을 기억하며 평안을 빕니다.'
            ],
            // 청첩(W)용 축하 메시지
            weddingMessageOptions: [
                '결혼을 진심으로 축하합니다.',
                '두 분의 앞날에 행복이 가득하길 바랍니다.',
                '언제나 사랑 넘치는 가정 이루세요.',
                '새로운 시작을 진심으로 축복합니다.'
            ],
            modalData: {}, // props 대신 data로 선언
        }
    },

    computed: {
        isMobile() {
            return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        },
        // 초대장 종류(W: 청첩/축하, F: 부고/애도)에 따라 메시지 옵션 선택
        messageOptions() {
            return this.modalData?.invitationType === 'W'
                ? this.weddingMessageOptions
                : this.funeralMessageOptions;
        },
        selectedMessage: {
            get() {
                if (this.messageOptions.includes(this.kiwoompay.message)) {
                    return this.kiwoompay.message;
                }
                return '';
            },
            set(newValue) {
                this.kiwoompay.message = newValue;
            }
        },

        // 합계 금액: 운영비 + 기부금
        totalAmount() {
            const base = Number(this.modalData?.paymentAmount ?? 0);
            const extra = Number(this.selectedExtra ?? 0);
            return base + extra;
        },
    },

    methods: {
        ...mapActions(paymentModule, [
            'verifyPayment',
            'kiwoomPayment',
            'createUniquePaymentId'
        ]),
        ...mapActions(apiGuideModule, [ 'requestCampaignByComIdPayment']),

        /* PortOne 결제 방식 변경
        async makePayment () {
            const paymentId = await this.createUniquePaymentId()
            const payment = await PortOne.requestPayment({
                storeId: env.api.STORE_ID,
                channelKey: env.api.CHANNEL_KEY,
                paymentId,
                orderName: this.modalData.campaignName,
                totalAmount: this.modalData.paymentAmount,
                currency: "KRW",
                payMethod: "CARD",
                customData: {
                item: "1"
                }
            })

            if (payment.code !== undefined) {
                this.$emit('close')
                this.$parent?.$openModal('alertModal', {
                    message: '결제에 실패했습니다. 다시 시도해 주세요.',
                });
                return;
            }

            const id = payment.paymentId
            const invitationSeq = this.modalData.invitationSeq
            const {name, phoneNum} = this
            const message = this.message.replace(/\n/g, '<br>')
            const result = await this.verifyPayment({id, invitationSeq, name, phoneNum, message})
            if (result.status === "PAID") {
                this.$emit('close')
                this.$parent?.$openModal('alertModal', {
                    message: '결제가 성공적으로 완료되었습니다! <br>' + '결제 정보는 홈페이지에서 <br>' + id + ' 로 확인 가능 합니다',
                });
            } else {
                this.$emit('close')
                this.$parent?.$openModal('alertModal', {
                    message: "결제 검증 실패! 고객센터 문의 필요",
                });
            }
            */

        async makePayment () {
            const invitationSeq = this.modalData.invitationSeq
            let orderno =  this.kiwoompay.orderno;
                if (!orderno || orderno === '') {
                    orderno = await this.createUniquePaymentId();
                }
            const message = this.kiwoompay.message.replace(/\n/g, '<br>')
            const {cpid, type, paymethod, amount, username, email, productname, producttype, taxfreecd, teln02, kiwoomEnc, phonenum, status}  = this.kiwoompay;

            // 운영비 + 기부금 매핑
            const amountToPay = this.totalAmount;

            const result = await this.kiwoomPayment({
                invitationSeq,
                orderno,
                cpid,
                type,
                paymethod,
                amount: amountToPay,
                username,
                email,
                productname: this.modalData.campaignName,
                producttype,
                taxfreecd,
                teln02,
                kiwoomEnc,
                phonenum,
                message,
                status
            })

            this.kiwoompay.cpid = result.cpid;
            this.kiwoompay.paymethod = result.paymethod;
            this.kiwoompay.taxfreecd = result.taxfreecd;
            this.kiwoompay.teln02 = result.teln02;
            this.kiwoompay.kiwoomEnc = result.kiwoomEnc; // 예: 응답 필드가 있을 경우
            this.kiwoompay.orderno = result.orderno;
            this.kiwoompay.status = result.status;

            console.log(this.kiwoompay);

            setTimeout(() => {

                if (result.status == "PAID") {
                    this.$emit('close')
                    this.$parent?.$openModal('alertModal', {
                    message: '결제가 성공적으로 완료되었습니다! <br>' + '결제 정보는 홈페이지에서 <br>' + orderno + ' 로 확인 가능 합니다',
                });

                } else {
                    alert('결제완료 후 확인하기 버튼을 클릭해주세요.');
                    window.open('', 'KIWOOMPAY', 'width=468,height=750');
                    this.$refs.paymentForm.target = 'KIWOOMPAY';
                    this.$refs.paymentForm.submit();
                    //this.$emit('close')
                    this.buttonText = '확인하기'
                }
            }, 1500)


        }

    },

    async mounted() {
        try {
            // URL 인코딩 후 호출
            const res = await axiosInst.springAxiosInst.get(
                `/company/invitation/payment/${this.orderNum}`
            );
            console.warn(res)
            if (res.data && res.data.status === "200") {
                const q = res.data.modalData;

                // 백엔드가 배열 형태로 내려줄 수도 있으므로 배열/객체 모두 대비
                const modal = Array.isArray(q) ? q[0] : q;

                this.modalData = {
                    campaignName: modal?.campaignName || "",
                    paymentAmount: Number(modal?.paymentAmount || 0),
                    invitationSeq: modal?.invitationSeq || "",
                    invitationType: modal?.invitationType || "", // 백엔드 응답의 W/F (없으면 애도 문구로 폴백)
                };

                this.kiwoompay.amount = this.totalAmount;
                this.kiwoompay.productname = this.modalData.campaignName;
                this.kiwoompay.type = this.isMobile ? "M" : "P";
                // 페이지 열릴 때 클래스 추가
                document.body.classList.add("payment-popup");
            } else {
                console.warn("API 응답 오류:", res.data.message);
            }
        } catch (err) {
            console.error("API 요청 실패:", err);
        }
    },
    unmounted() {
        // 페이지 닫힐 때 클래스 제거
        document.body.classList.remove('payment-popup');
    },

    watch: {
        // 추가 금액 변동 시 히든필드용 amount도 동기화(필요시)
        totalAmount(newVal) {
            this.kiwoompay.amount = newVal;
        }
    }
}
</script>
<style >
    .form_wrap select { appearance: auto; }
    /* 전역 레이아웃 감춤 */
    body.payment-popup #header,
    body.payment-popup #footer,
    body.payment-popup .modal_close {
    display: none !important;
    }

    body.payment-popup .title {
    display: block !important;
    }
    .payment-window {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: #fff;
    }

    /* 모바일: 라벨을 인풋 위로 올리고 인풋을 100%로 통일해 정렬을 맞춘다 */
    @media screen and (max-width: 720px) {
        body.payment-popup .modal .member .form_wrap {
            display: block;
        }
        body.payment-popup .modal .member .form_wrap .title {
            margin-bottom: 8px;
        }
        /* 값이 없는 라벨(메시지 textarea 위)은 감춰 불필요한 여백 제거 */
        body.payment-popup .modal .member .form_wrap .title:empty {
            display: none !important;
        }
        body.payment-popup .modal .member input[type="text"],
        body.payment-popup .modal .member .select_message,
        body.payment-popup .modal .member .textarea {
            width: 100%;
            box-sizing: border-box;
        }
    }
</style>